import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr2005',
    ecrans: ['00-2']
});
